<template>
    <div>
        <page-header>
            {{ $t('dashboard.title') }}
            <template #side>
                <ButtonIcon
                    class="mr-2"
                    icon="refresh-cw"
                    variant="link"
                    :disabled="loading"
                    :icon-animation="iconAnimation"
                    @click="reload"
                />
                <TimeRangeCalendar
                    v-model="timeRange"
                    :disabled="loading"
                    :options="['today', 'yesterday', 'last7Days', 'currentWeek', 'last14Days', 'last30days', 'currentMonth', 'currentQuarter', 'currentYear']"
                />
            </template>
        </page-header>

        <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.transactions')"
                    :value="$format.number(orders.orders)"
                    :difference="$format.percent(percentDiff(orders.orders, orders.orders_compare))"
                    :loading="requestOrdersStats.getLoading()"
                    :error="requestOrdersStats.getError()"
                    tooltip-formatter="round"
                />
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.ourCommission')"
                    :value="$format.currency(commission.admin_commission)"
                    :difference="$format.percent(percentDiff(commission.admin_commission, commission.admin_commission_compare))"
                    :loading="requestCommissionStats.getLoading()"
                    :error="requestCommissionStats.getError()"
                    tooltip-formatter="currency"
                />
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.newPublishers')"
                    :value="$format.number(publisherQuantity.quantity)"
                    :difference="$format.percent(percentDiff(publisherQuantity.quantity, publisherQuantity.quantity_compare))"
                    :loading="requestPublisherQuantityStats.getLoading()"
                    :error="requestPublisherQuantityStats.getError()"
                    tooltip-formatter="round"
                />
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.newSpaces')"
                    :value="$format.number(spacesQuantity.quantity)"
                    :difference="$format.percent(percentDiff(spacesQuantity.quantity, spacesQuantity.quantity_compare))"
                    :loading="requestSpacesQuantityStats.getLoading()"
                    :error="requestSpacesQuantityStats.getError()"
                    tooltip-formatter="round"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <MultiEChartCard
                    :data="chartOverview"
                    :loading="isChartOverviewLoading"
                    :title="$t('dashboard.overview')"
                    type="time"
                    @currentChart="setCurrentChart"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 mb-4">
                <WidgetNewSpaces ref="widgetNewSpaces" />
            </div>
        </div>
    </div>
</template>



<script>
    import DashboardMixin from '@/views/common/dashboard/index.vue';
    import WidgetNewSpaces from '@/views/common/dashboard/parts/WidgetNewSpaces.vue';

    export default {
        name: 'AdminDashboard',
        mixins: [DashboardMixin],
        components: {
            WidgetNewSpaces,
        },
        computed: {
            loading() {
                return (
                    this.requestOrdersStats.getLoading() ||
                    this.requestCommissionStats.getLoading() ||
                    this.requestPublisherQuantityStats.getLoading() ||
                    this.requestSpacesQuantityStats.getLoading() ||
                    this.requestOrdersChart.getLoading() ||
                    this.requestAdminCommissionChart.getLoading() ||
                    this.requestAdvertiserCommissionChart.getLoading() ||
                    this.isChartOverviewLoading
                );
            },
            iconAnimation() {
                return this.loading ? 'spin' : undefined;
            },
            chartOverview() {
                return {
                    orders: this.getChartData(this.ordersChart.chart, 'orders', this.$t('dashboard.transactions'), '#546af8'),
                    adminCommission: this.getChartData(this.adminCommissionChart.chart, 'admin_commission', this.$t('dashboard.ourCommission'), '#f67e53', 'currency'),
                    advertiserCommission: this.getChartData(this.advertiserCommissionChart.chart, 'advertiser_commission', this.$t('dashboard.advertiserCommission'), '#43d29e', 'currency'),
                };
            },
            isChartOverviewLoading() {
                return this.requestOrdersChart.getLoading() || this.requestAdminCommissionChart.getLoading() || this.requestAdvertiserCommissionChart.getLoading();
            },
        },
        methods: {
            fetchData(params = {}) {
                this.fetchOrdersStats(params);
                this.fetchCommissionStats(params);
                this.fetchPublisherQuantityStats(params);
                this.fetchSpacesQuantityStats(params);
                this.fetchOrdersChart(params);
                this.fetchAdminCommissionChart(params);
                this.fetchAdvertiserCommissionChart(params);
            },
            reload() {
                const params = { cache: false };
                this.fetchData(params);
                this.$refs.widgetNewSpaces.fetchData(params);
            },
        },
    };
</script>
